module.exports = {
  sm: "480px",
  md: "768px",
  desk: "1280px",
  xl: "1440px",
  fhd: "1920px",
}
